/* 
 - TODO: Explanation
*/

class UserPermissions {
    editPrivs: boolean;
  
    constructor(editPrivs: boolean) {
      this.editPrivs = editPrivs;
    }
  }
  
  export default UserPermissions;
  